/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const c = (t, e) => e.kind === "method" && e.descriptor && !("value" in e.descriptor) ? { ...e, finisher(r) {
  r.createProperty(e.key, t);
} } : { kind: "field", key: Symbol(), placement: "own", descriptor: {}, originalKey: e.key, initializer() {
  typeof e.initializer == "function" && (this[e.key] = e.initializer.call(this));
}, finisher(r) {
  r.createProperty(e.key, t);
} };
function a(t) {
  return (e, r) => r !== void 0 ? ((i, n, o) => {
    n.constructor.createProperty(o, i);
  })(t, e, r) : c(t, e);
}
export {
  a as n
};
//# sourceMappingURL=property-BWlAHqg_.js.map
